<template>
  <div>
    <b-modal :id="modal_id" title="インポート" size="xl" :header-bg-variant="'dark'" :header-text-variant="'light'"
      :body-bg-variant="'light'" @hide="closeModal" hide-footer centered modal-class="custom-modal" scrollable>
      <!-- 一覧 -->
      <div>
        <div style="width: 1200px; ">
          <!-- 発注先を選択 -->
          <span v-if="master_name == 'mitumori'">
            <div class="form-inline">
              1.発注先を選択
            </div>
            <div class="form-inline" style="">
              <b-form-select v-model="hattyu_company_sel" @change="SelHattyuCompany"
                style="width: 200px; margin-left: 10px;">
                <option v-for="option in hattyu_company_list" v-bind:value="option.value" :key="option.id">
                  {{ option.text }}
                </option>
              </b-form-select>
            </div>
            <hr />
          </span>
          <!-- 発注先を選択 -->
          <span v-if="master_name == 'mitumori'">
            <div class="form-inline">
              2.品題、品類、品目を設定
            </div>
            <div class="form-inline" style="">
              <table class="header_tbl" style="margin-left: 10px;  margin-top: -10px;">
                <tr>
                  <th style="width: 200px">品題</th>
                  <th style="width: 200px">品類</th>
                  <th style="width: 200px">品目</th>
                </tr>
                <tr>
                  <td>
                    <b-input v-model="title" type="text" style="width:180px; background-color: white;" />
                  </td>
                  <td>
                    <b-input v-model="teiki_type1" type="text" style="width:180px; background-color: white;" />
                  </td>
                  <td>
                    <b-input v-model="teiki_type2" type="text" style="width:180px; background-color: white;" />
                  </td>
                </tr>
              </table>
            </div>
            <hr />
          </span>
          <!-- CSVファイルを選択 -->
          <div v-if="master_name == 'mitumori'" class="form-inline">
            3.CSVファイルを選択
            &nbsp;&nbsp;&nbsp;※ファイルの種類(エンコード)は「UTF-8」にして下さい
          </div>
          <div style="margin-left: 20px">
            <b-form-file v-model="csv_file" :state="Boolean(csv_file)" accept="text/csv"
              placeholder="Choose a file or drop it here..." @change="upload_csv_file"
              style="width: 500px; text-align: left !important; float: left !important;"></b-form-file>
          </div>
          <br><br>
          <hr />
          <!-- ヘッダーを設定 -->
          <div v-if="master_name == 'mitumori'" class="form-inline">
            4.ヘッダーを設定
          </div>
          <div v-if="master_name == 'mitumori'" class="form-inline">
            <table class="header_tbl" style="margin-left: 10px;">
              <tr>
                <th>納品書番号</th>
                <th>受注日</th>
                <th>顧客名</th>
                <th>商品コード</th>
                <th>数量</th>
                <th>単価(税抜)</th>
                <th>単価(税込)</th>
                <th>税率</th>
              </tr>
              <tr>
                <td v-for="n in 8" v-bind:key="n">
                  <b-form-select v-model="header_sel[n - 1]" style="width: 130px" @change="onHeaderChanged(n - 1)">
                    <option />
                    <option v-for="option in header_list" v-bind:value="option.value" :key="option.id">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </td>
              </tr>
            </table>
          </div>
          <hr />
          <!-- 顧客名を設定 -->
          <div v-if="master_name == 'mitumori'" class="form-inline">
            5.顧客、担当者を設定
          </div>
          <div v-if="master_name == 'mitumori'" class="form-inline" style="margin-left: 10px;">
            <SelectClientCompany ref="select_client_company_ref" @on_select='onClientCompanySelect' />
          </div>
          <div v-if="master_name == 'mitumori'" class="form-inline">
            <table class="header_tbl" style="margin-left: 10px;  margin-top: -10px;">
              <tr>
                <th style="width: 280px">import元</th>
                <th style="width: 280px">import先</th>
                <th style="width: 150px">担当者</th>
              </tr>
              <tr v-for="(list, i) in bef_client_company_list" v-bind:key="i">
                <td style="max-width: 280px">{{ list }}</td>
                <td style="max-width: 280px">
                  <b-input v-model="aft_client_company_list[i][1]" type="text"
                    style="width:200px; background-color: white;" @click="selectClientCompanyModalShow(i)" readonly />
                  <b-button v-if="!loading[i]" @click="selectClientCompanyModalShow(i)" variant="info" class="icon_btn">
                    <b-icon icon="search" aria-hidden="true"></b-icon>
                  </b-button>
                  <b-button v-if="loading[i]" variant="info" class="icon_btn" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </b-button>
                </td>
                <td style="width: 150px">
                  <b-form-select v-model="aft_user_list[i]" style="width: 200px; margin-left: 10px;"
                    @change="onUserChange(i)">
                    <option v-for="option in sel_person" v-bind:value="option.value" :key="option.id">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </td>
              </tr>
            </table>
          </div>
          <div v-if="master_name == 'mitumori'" class="form-inline">
            <div style="margin-left: 800px">
              インポート済みの納品書番号は保存されません
            </div>
            <b-button v-if="!import_flg" @click="csvImport" variant="primary"
              style="margin-left: 985px; width: 150px !important">
              <b-icon icon="save"></b-icon>&nbsp;インポート
            </b-button>
            <b-button v-if="import_flg" variant="primary" disabled style="margin-left: 985px; width:150px !important;">
              <b-spinner small></b-spinner>
              Loading...
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: ['modal_id'],
  // axiosInstance,
  mounted() {
  },
  data: function () {
    return {
      loading: [],
      master_name: "",
      title: "",
      teiki_type1: "",
      teiki_type2: "",
      csv_file: null,
      upload_file: null,
      import_flg: false,
      header_list: [],
      header_sel: [],
      sel_person: [],
      hattyu_company_list: [],
      user_id: 0,
      hattyu_company_sel: 0,
      bef_client_company_list: [],
      aft_client_company_list: [],
      aft_user_list: [],
      sel_client_company_index: 0,
      maxHeight: document.documentElement.scrollHeight - 300 + "px"
    }
  },
  methods: {
    closeModal: function (id) {
      this.$emit('close_modal', id);
    },
    //
    setImportType: function (masterName) {
      this.master_name = masterName;
      this.header_list = [];
      this.header_sel = [];
      this.csv_file = null;
      this.upload_file = null;
      this.csv_ini();
    },
    // 発注先選択
    SelHattyuCompany: function () {
      this.header_list = [];
      this.header_sel = [];
      this.csv_file = null;
      this.upload_file = null;
    },

    // 初期処理
    csv_ini: function (e) {
      axios
        .get('/mitumori/mitumori_csv_ini', { params: { master_name: this.master_name } }
        ).then(response => {
          this.sel_person = response.data.sel_person
          this.user_id = response.data.user_id
          this.hattyu_company_list = response.data.hattyu_company_list;
          this.hattyu_company_sel = 1//this.hattyu_company_list[0].value
        })
    },
    // import2  CSVファイルを選択
    upload_csv_file: function (e) {
      const params = new FormData();
      if (e !== undefined) {
        this.upload_file = (e.target.files || e.dataTransfer.files)[0]
      }
      params.append("master_name", this.master_name);
      params.append("hattyu_company", this.hattyu_company_sel);
      params.append("select_list", this.header_sel);
      params.append("csv_file", this.upload_file);
      axios
        .post("mitumori/mitumori_upload_csv_file", params, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "XXXXXXXXXXXX",
          },
        })
        .then((response) => {
          this.header_list = response.data.header_list;
          this.header_sel = response.data.header_sel;
          this.bef_client_company_list = response.data.bef_client_company_list
          this.aft_client_company_list = response.data.aft_client_company_list;
          this.aft_user_list = response.data.aft_user_list;
          this.loading = Array(this.bef_client_company_list.length).fill(false);
          if (e !== undefined) {
            alert("読み込みました")
          }
        })
        .catch((error) => {
          console.error(error, error.response);
          return;
        });
    },
    // 3.ヘッダ設定
    onHeaderChanged: function (index) {
      // 顧客名変更
      if (index === 2) {
        this.upload_csv_file()
      }
    },
    // 4.顧客設定
    // 顧客選択モーダル表示
    selectClientCompanyModalShow: function (index) {
      this.loading[index] = true;
      this.sel_client_company_index = index
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'select-client-company');
        this.loading[index] = false;
      }, 50);
    },
    // 顧客選択
    onClientCompanySelect: function (company_id) {
      axios
        .get(`/mitumori/get_sel_client_person/${company_id}`)
        .then(response => {
          this.$set(this.aft_client_company_list, this.sel_client_company_index, [company_id, response.data.client_company_name])
          this.$set(this.aft_user_list, this.sel_client_company_index, response.data.user_id)
          axios
            .post("mitumori/set_client_company",
              {
                in_client_name: this.bef_client_company_list[this.sel_client_company_index],
                company_id: company_id
              })
            .then((response) => {
              this.$root.$emit('bv::hide::modal', 'select-client-company')
            })
            .catch((error) => {
              console.error(error, error.response);
              return;
            });
        })
    },
    // 担当者変更
    onUserChange: function (index) {
      axios
        .post("mitumori/set_user",
          {
            in_client_name: this.bef_client_company_list[index],
            company_id: this.aft_client_company_list[index],
            user_id: this.aft_user_list[index]
          })
        .then((response) => {
          this.$root.$emit('bv::hide::modal', 'select-client-company')
        })
        .catch((error) => {
          console.error(error, error.response);
          return;
        });
    },
    // インポート
    csvImport: function () {
      //
      for (const client of this.aft_client_company_list) {
        if (client[0] === null) {
          alert("顧客名が設定されていません");
          return;
        }
      }
      //
      for (const user of this.aft_user_list) {
        if (user === null) {
          alert("担当者が設定されていません");
          return;
        }
      }
      //
      const params = new FormData();
      if (this.csv_file !== null) {
        if (this.hasDuplicateValue(this.header_sel)) {
          alert("ヘッダーが重複しています")
        } else {
          this.import_flg = true;
          params.append("master_name", this.master_name);
          params.append("select_list", this.header_sel);
          params.append("hattyu_company", this.hattyu_company_sel);
          params.append("title", this.title);
          params.append("teiki_type1", this.teiki_type1);
          params.append("teiki_type2", this.teiki_type2);
          params.append("csv_file", this.upload_file);
          axios
            .post("mitumori/mitumori_csv_import", params, {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "XXXXXXXXXXXX",
              },
            })
            .then((response) => {
              this.import_flg = false;
              alert(response.data.msg)
            })
            .catch((error) => {
              this.import_flg = false;
              alert("不明なエラー")
              return;
            });
        }
      } else {
        alert("ファイルを選択してください")
      }
    },
    // 配列の重複チェック
    hasDuplicateValue: function (array) {
      var newArray;
      newArray = array.filter(n => n !== "");
      const set = new Set(newArray);
      return newArray.length !== set.size;
    }
  }
}
</script>

<style scoped>
.header_tbl th {
  background-color: #3a6e98;
  color: white;
  border: 0.5px solid white !important;
  text-align: center;
  margin: 5px 20px;
}

.header_tbl td {
  border: 0.5px solid gray !important;
}

.header_tbl th,
.header_tbl td {
  padding: 10px 5px;
  margin: 10px;
}

/* モーダル本体に max-height 指定し、body 内部をスクロール */
.custom-modal .modal-dialog {
  max-height: 90vh;
}

.custom-modal .modal-content {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.custom-modal .modal-body {
  overflow-y: auto;
  flex-grow: 1;
}
</style>